import { AppBar, Tabs as MuiTabs } from '@mui/material';
import React, { useContext } from 'react';

import PropTypes from 'prop-types';
import { ScrollbarContext } from 'react-scrollbars-custom';
import makeStyles from '@mui/styles/makeStyles';
import styles from './Tabs.styles';
import { translate } from '../../helpers/i18n';
import useBoundCallback from '../../helpers/Hooks/useBoundCallback';

const useStyles = makeStyles(styles);

const Tabs = props => {
    const {
        ariaLabel,
        className,
        color,
        children,
        elevation,
        onChange,
        orientation,
        preventScrollOnChange,
        ...remain
    } = props;
    const classes = useStyles(props);
    const scrollerContext = useContext(ScrollbarContext);

    const handleChange = useBoundCallback(
        (onChange, preventScrollOnChange, event, newValue) => {
            onChange && onChange(event, newValue);
            !preventScrollOnChange && scrollerContext?.parentScrollbar?.scrollToTop();
        },
        [onChange, preventScrollOnChange]
    );

    return (
        <AppBar
            position="static"
            classes={{ root: classes.appBar }}
            className={
                orientation === 'vertical' ? classes.appBarVertical : classes.appBarHorizontal
            }
            color={color}
            elevation={elevation}
        >
            <MuiTabs
                {...remain}
                onChange={handleChange}
                aria-label={translate(ariaLabel)}
                orientation={orientation}
                className={className}
                classes={{
                    root: classes.tabs,
                    vertical: classes.verticalTabs,
                    indicator: classes['MuiTabs-indicator'],
                    flexContainerVertical: classes['MuiTabs-flexContainerVertical'],
                }}
            >
                {children}
            </MuiTabs>
        </AppBar>
    );
};

Tabs.propTypes = {
    ariaLabel: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    color: PropTypes.string,
    elevation: PropTypes.number,
    initialTab: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    orientation: PropTypes.oneOf(['horizontal', 'vertical']),
    preventScrollOnChange: PropTypes.bool,
    tab: PropTypes.string,
    textColor: PropTypes.string,
};

Tabs.defaultProps = {
    color: 'tertiary',
    textColor: 'inherit',
};

export default Tabs;
